import { useEffect, useState } from 'react'
import settingsService from '@api/v1/settingsService'

/**
 * CC-49752 / CC-49949 — resolve the tenant's `UsePosting` server setting once.
 *
 * Legacy pages branch their Invoice Posted? behavior on
 * `Centerbase.globalSettings.usePosting()`: Aged A/R defaults the filter to
 * "Posted" on posting tenants (ARReportHomeView), and Production & Origination
 * additionally HIDES the control on non-posting tenants
 * (RevenueAndCommissionsHomeView). The same value is a plain server setting
 * (legacy: `GetServerSettingBool("UsePosting", false)`), readable through the
 * existing /settings/server endpoint — no cb-api change.
 *
 * Returns `{ ready, usePosting }`. `ready` flips true exactly once, after the
 * read settles (success OR error), so pages can gate their first auto-run on
 * the resolved default and never run with a default the controls don't show.
 * Fail-soft: any error resolves to `usePosting: false` (legacy's non-posting
 * branch).
 */
export const USE_POSTING_SETTING = 'UsePosting'

const useUsePosting = () => {
  const [state, setState] = useState({ ready: false, usePosting: false })

  useEffect(() => {
    let cancelled = false
    ;(async () => {
      let usePosting = false
      try {
        const s = await settingsService.getServerSettings([USE_POSTING_SETTING])
        usePosting = settingsService.toBool(s?.[USE_POSTING_SETTING], false)
      } catch { /* fail soft — non-posting behavior */ }
      if (!cancelled) setState({ ready: true, usePosting })
    })()
    return () => { cancelled = true }
  }, [])

  return state
}

export default useUsePosting
